import React from 'react';
import "../style/component/FooterModal.css";

const FooterModal = ({ openModal }) => {
  const policies = {
    terms: {
      title: "Terms & Policy",
      content: `<p>
        Effective Date: 20th July, 2025 (Version 1.0)<br/><br/>
        Welcome to <strong>SkinForge!</strong> skinforge.fun (the "Website") and all related services, products, and content are owned and operated by DIGITRACEUP LIMITED, registered in Nicosia, Cyprus.<br/><br/>
        Please read these Terms & Conditions ("Terms") carefully before using our Website and services. By accessing or using the Website, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, you may not access the Website or use our services.
        <br/><br/>
        
        <strong>1. Acceptance of Terms</strong><br/>
        You confirm that you are at least 18 years old, or if you are a minor, you have parental/guardian consent. Your parent/guardian is responsible for your use and purchases.
        <br/><br/>
        
        <strong>2. Our Service</strong><br/>
        SkinForge sells digital assets, specifically gaming skins ("Products"). These are cosmetic items for third-party games and have no real-world value.<br/>
        <em>Note:</em> Purchases grant a limited, non-exclusive, non-transferable, revocable license for personal, non-commercial entertainment. You do not gain ownership or IP rights.
        <br/><br/>
        
        <strong>3. User Account</strong><br/>
        • Provide accurate, current, complete information.<br/>
        • Keep your password secure and accept risks of unauthorized access.<br/>
        • Notify us of any suspected breaches.<br/>
        • Do not sell, transfer, or share your account.<br/>
        We may suspend/terminate accounts if these Terms are violated.
        <br/><br/>
        
        <strong>4. Purchase and Payments</strong><br/>
        • <u>Pricing:</u> All prices in USD, subject to change. Price at checkout is final.<br/>
        • <u>Taxes:</u> May apply depending on your jurisdiction.<br/>
        • <u>Payment:</u> Handled by third-party processors under their terms.<br/>
        • <u>Chargebacks:</u> Fraudulent claims lead to permanent bans and possible legal action.
        <br/><br/>
        
        <strong>5. Refunds and Returns</strong><br/>
        All sales are final (digital goods). Refunds only if:<br/>
        • Product is non-functional due to our error.<br/>
        • Refund is legally required.<br/>
        Requests must be sent to support@skinforge.fun within 72 hours of purchase.
        <br/><br/>
        
        <strong>6. Intellectual Property</strong><br/>
        All Website content, logos, designs, and Products are property of DIGITRACEUP LIMITED/licensors. Protected by IP laws. No reproduction or distribution without consent.
        <br/><br/>
        
        <strong>7. Prohibited Conduct</strong><br/>
        • Illegal or unauthorized use.<br/>
        • Reselling or commercial exploitation of Products.<br/>
        • Use of bots, automation, or scripts.<br/>
        • Interfering with Website functionality.<br/>
        • Abusive, harassing, or harmful behavior.
        <br/><br/>
        
        <strong>8. Disclaimers</strong><br/>
        • Website/Products provided "as is," without warranties.<br/>
        • SkinForge is not affiliated with game developers/publishers and not responsible for their policies or service changes.
        <br/><br/>
        
        <strong>9. Limitation of Liability</strong><br/>
        SkinForge is not liable for indirect, incidental, or consequential damages (e.g., profit, data, goodwill loss). Liability capped at amount paid in past 6 months.
        <br/><br/>
        
        <strong>10. Indemnification</strong><br/>
        You agree to indemnify and hold harmless SkinForge, its officers, employees, and agents from claims, damages, and expenses arising from your Website use or violations.
        <br/><br/>
        
        <strong>11. Governing Law & Dispute Resolution</strong><br/>
        Governed by UK law. Disputes resolved by binding arbitration at the London Court of International Arbitration.
        <br/><br/>
        
        <strong>12. Changes to Terms</strong><br/>
        We may update Terms at any time. Changes posted on the Website. Continued use = acceptance of updates.
        <br/><br/>
        
        <strong>Contact</strong><br/>
        For questions about these Terms:<br/>
        Email: support@skinforge.fun<br/>
        Website: <a href="https://skinforge.fun">skinforge.fun</a><br/>
      </p>`
    },
    privacy: {
      title: "Privacy Policy",
      content: `<p>
        Last Updated: 20th July, 2025 (Version 1.0)<br/><br/>
        This Privacy Policy explains how skinforge.fun ("we," "us," or "our") collects, uses, and protects your personal information when you use our website. We believe in being transparent and honest about your data.
        <br/><br/>
        
        <strong>1. The Data We Collect</strong><br/>
        When you use our website, we collect information to make our service work and to improve your experience. This includes:<br/><br/>
        • <u>Information you give us:</u> When you sign up, we collect your email address and username. If you make a purchase, we also collect transaction details.<br/><br/>
        • <u>Information collected automatically:</u> We use cookies and similar technologies to remember your preferences, keep you logged in, and analyze how you use our site. This helps us understand which features are popular and where we can improve. We also collect your IP address to prevent fraud and secure your account.
        <br/><br/>
        
        <strong>2. How We Use Your Data</strong><br/>
        We use your information for key purposes:<br/><br/>
        • To provide our service: creating your account, processing purchases, and delivering items.<br/>
        • To improve our service: analyzing usage to fix bugs, optimize performance, and build new features.<br/>
        • To communicate with you: sending updates, product news, or promotions (unsubscribe anytime).<br/>
        • For security & fraud prevention: protecting accounts and preventing illegal activities.
        <br/><br/>
        
        <strong>3. Sharing Your Data</strong><br/>
        We do not sell your personal data. We only share it in limited cases:<br/><br/>
        • <u>Third-party providers:</u> payment processors (e.g., Stripe, PayPal), analytics (e.g., Google Analytics), hosting services. They only receive what’s needed and must protect your data.<br/>
        • <u>Legal obligations:</u> if required by law, court order, or to protect rights/safety.<br/>
        • <u>Business transfers:</u> if SkinForge is merged, acquired, or sold, your info may be transferred.
        <br/><br/>
        
        <strong>4. Your Rights & Choices</strong><br/>
        You control your personal information:<br/><br/>
        • <u>Access & Correction:</u> request a copy of your personal data or ask for corrections.<br/>
        • <u>Deletion:</u> request account deletion (except legally required data).<br/>
        • <u>Opt-out:</u> unsubscribe from marketing emails anytime via the link provided.
        <br/><br/>
        
        <strong>5. Data Security</strong><br/>
        We use encryption, secure servers, and other measures to protect your data. However, no method of transmission online is 100% secure.
        <br/><br/>
        
        <strong>6. Cookies</strong><br/>
        Our site uses cookies to improve your experience. Cookies help us remember you. You can disable them in your browser, but some site features may not work properly.
        <br/><br/>
        
        <strong>7. International Data Transfers</strong><br/>
        Our servers are located in <em>Server Location (e.g., United States)</em>. By using our website outside of this region, you consent to your information being transferred, stored, and processed there.
        <br/><br/>
        
        <strong>8. Changes to This Policy</strong><br/>
        We may update this Privacy Policy from time to time. Updates will be reflected by the "Last Updated" date at the top. Please review periodically.
        <br/><br/>
        
        <strong>9. Contact Us</strong><br/>
        If you have any questions about this Privacy Policy or how we handle your data, please contact us at:<br/>
        Email: support@skinforge.fun<br/>
        Website: <a href="https://skinforge.fun">skinforge.fun</a><br/>
      </p>`
    },
    cookies: {
      title: "Cookies Policy",
      content: `<p>
        Last Updated: 20th July, 2025 (Version 1.0)<br/><br/>
        This Cookie Policy explains what cookies are, how we use them, and your choices regarding our use of cookies when you visit <strong>skinforge.fun</strong>.<br/><br/>
        
        <strong>1. What Are Cookies?</strong><br/>
        Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide a better browsing experience. Cookies can be <u>session cookies</u> (temporary, deleted when you close your browser) or <u>persistent cookies</u> (which remain on your device for a set period or until you delete them).
        <br/><br/>
        
        <strong>2. How We Use Cookies</strong><br/>
        We use cookies for several important reasons:<br/><br/>
        • <u>Essential Cookies:</u> Required for the website to function correctly (e.g., navigation, login, checkout).<br/><br/>
        • <u>Performance & Analytics Cookies:</u> Collect anonymous data to understand usage, measure performance, and fix errors to improve the site.<br/><br/>
        • <u>Functionality Cookies:</u> Remember preferences such as language, currency, or login details to personalize your experience.<br/><br/>
        • <u>Advertising Cookies:</u> May be used (in the future) to deliver ads relevant to your interests and track browsing behavior across websites.<br/><br/>
        
        <strong>3. Your Choices</strong><br/>
        You have control over cookies and can manage them via your browser settings. Most browsers allow you to:<br/><br/>
        a. View cookies on your device and delete them.<br/>
        b. Block third-party cookies.<br/>
        c. Block cookies from specific websites.<br/>
        d. Block all cookies.<br/><br/>
        Please note: disabling essential cookies may prevent some parts of the site from working correctly.
        <br/><br/>
        
        <strong>4. Retention of Cookies</strong><br/>
        • <u>Session cookies</u> expire when you close your browser.<br/>
        • <u>Persistent cookies</u> remain for a reasonable period or until you manually delete them.<br/><br/>
        
        <strong>5. Changes to This Policy</strong><br/>
        We may update this Cookie Policy to reflect changes in our practices or legal requirements. Updates will be reflected by the "Last Updated" date at the top. Please review periodically.
        <br/><br/>
        
        <strong>6. Contact Us</strong><br/>
        If you have any questions about our use of cookies, please contact us at:<br/>
        Email: support@skinforge.fun<br/>
        Website: <a href="https://skinforge.fun">skinforge.fun</a><br/>
      </p>`
    }
  };

  const openPolicyModal = (policyType) => {
    openModal(policies[policyType].content, policies[policyType].title);
  };

  return (
    <div className="terms">
      <h3>Terms & Condition : </h3>
      <p onClick={() => openPolicyModal("terms")}>Terms & Policy</p>
      <p onClick={() => openPolicyModal("privacy")}>Privacy Policy</p>
      <p onClick={() => openPolicyModal("cookies")}>Cookies Policy</p>
    </div>
  );
};

export default FooterModal;